import React, { Component } from "react";
import { Card, CardBody, Col, Form, Input, Row } from "reactstrap";
import PropTypes from "prop-types";
import DefaultMultipleSelect from "../DefaultMultipleSelect/DefaultMultipleSelect";
import queryString from "query-string";
import styled from "styled-components";

class FormToFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filter_name: [],
      mediaBuyers: null,
      offerTypes: null,
      budgetFilter: false,
      filterBudgetFrom: null,
      filterBudgetTo: null,
    };
  }

  componentDidMount() {
    const parsedSearch = queryString.parse(this.props.history.location.search);
    let formQueryString = queryString.stringify(parsedSearch);
    if (this.props.history.location.hash.length > 0) {
      const parsedHash = this.props.history.location.hash;
      this.props.history.location.search = formQueryString;
      this.props.history.location.hash = parsedHash;
      this.props.history.replace(this.props.history.location);
    } else {
      this.props.history.location.search = formQueryString;
      this.props.history.replace(this.props.history.location);
    }

    this.setState({
      offerTypes: this.props.offers,
      mediaBuyers: this.props.dataForAddBudget?.mediaBuyers,
    });
    this.handleChangeBudgetFrom(parsedSearch.from);
    this.handleChangeBudgetTo(parsedSearch.to);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { dataForAddBudget } = this.props;

    if (prevProps.offers !== this.props.offers) {
      this.setState({
        offerTypes: this.props.offers,
      });
    }

    if (prevProps.dataForAddBudget !== dataForAddBudget) {
      this.setState({
        mediaBuyers: dataForAddBudget.mediaBuyers,
      });
    }

    if (
      prevState.filterBudgetFrom !== this.state.filterBudgetFrom ||
      prevState.filterBudgetTo !== this.state.filterBudgetTo
    ) {
      this.handleFiltering();
    }
  }

  handleSelectedMediaBuyers = (data, _) => {
    const { mediaBuyers } = this.state;
    let filteredData = [];
    let prevHistory = queryString.parse(this.props.history.location.search);

    let dt = mediaBuyers.concat([]);

    for (let i in dt) {
      dt[i].checked = data.find(x => x.value == dt[i].id) !== undefined;
    }

    data.map(i => filteredData.push(i.value));

    let formQueryString = queryString.stringify(
      Object.assign(prevHistory, {
        media_buyer: filteredData,
      })
    );

    if (this.props.history.location.hash.length > 0) {
      const parsedHash = this.props.history.location.hash;
      this.props.history.location.search = formQueryString;
      this.props.history.location.hash = parsedHash;
      this.props.history.replace(this.props.history.location);
    } else {
      this.props.history.location.search = formQueryString;
      this.props.history.replace(this.props.history.location);
    }
    this.setState({ mediaBuyers: dt });
    this.handleFiltering();
  };

  handleSelectedOffers = (data, _) => {
    const { offerTypes } = this.state;
    let filteredData = [];
    let prevHistory = queryString.parse(this.props.history.location.search);
    let dt = offerTypes.concat([]);

    for (let i in dt) {
      dt[i].checked = data.find(x => x.value == dt[i].id) !== undefined;
    }

    data.map(i => filteredData.push(i.value));

    let formQueryString = queryString.stringify(
      Object.assign(prevHistory, {
        offer: filteredData,
      })
    );

    if (this.props.history.location.hash.length > 0) {
      const parsedHash = this.props.history.location.hash;
      this.props.history.location.search = formQueryString;
      this.props.history.location.hash = parsedHash;
      this.props.history.replace(this.props.history.location);
    } else {
      this.props.history.location.search = formQueryString;
      this.props.history.replace(this.props.history.location);
    }
    this.setState({ offerTypes: dt });
    this.handleFiltering();
  };

  handleChangeBudgetFrom = sum => {
    let prevHistory = queryString.parse(this.props.history.location.search);
    let formQueryString = queryString.stringify(
      Object.assign(prevHistory, {
        from: sum?.length > 0 ? sum : [],
      })
    );

    if (this.props.history.location.hash.length > 0) {
      let parsedHash = this.props.history.location.hash;
      this.props.history.location.search = formQueryString;
      this.props.history.location.hash = parsedHash;
      this.props.history.replace(this.props.history.location);
    } else {
      this.props.history.location.search = formQueryString;
      this.props.history.replace(this.props.history.location);
    }

    sum > 0
      ? this.setState({ filterBudgetFrom: sum })
      : this.setState({ filterBudgetFrom: null });
  };

  handleChangeBudgetTo = sum => {
    let prevHistory = queryString.parse(this.props.history.location.search);
    let formQueryString = queryString.stringify(
      Object.assign(prevHistory, {
        to: sum?.length > 0 ? sum : [],
      })
    );

    if (this.props.history.location.hash.length > 0) {
      let parsedHash = this.props.history.location.hash;
      this.props.history.location.search = formQueryString;
      this.props.history.location.hash = parsedHash;
      this.props.history.replace(this.props.history.location);
    } else {
      this.props.history.location.search = formQueryString;
      this.props.history.replace(this.props.history.location);
    }

    sum > 0
      ? this.setState({ filterBudgetTo: sum })
      : this.setState({ filterBudgetTo: null });
  };

  handleFiltering = () => {
    const { offerTypes, mediaBuyers, filterBudgetFrom, filterBudgetTo } =
      this.state;

    let offers = [];
    let buyers = [];
    let offerRow = "";
    let buyerRow = "";
    let budget_from = "";
    let budget_to = "";

    for (let i in offerTypes) {
      if (offerTypes[i].checked) {
        offers.push(offerTypes[i]);
        offerRow += "offer=" + offerTypes[i].id + "&";
      }
    }

    for (let i in mediaBuyers) {
      if (mediaBuyers[i].checked) {
        buyers.push(mediaBuyers[i]);
        buyerRow += "media_buyer=" + mediaBuyers[i].id + "&";
      }
    }

    if (filterBudgetFrom !== 0 && filterBudgetFrom !== null) {
      if (this.props.FilterType === "budget") {
        budget_from = `budget_from=${filterBudgetFrom}&`;
      } else if (this.props.FilterType === "plans") {
        budget_from = `planned_sum_from=${filterBudgetFrom}&`;
      }
    }

    if (filterBudgetTo !== 0 && filterBudgetTo !== null) {
      if (this.props.FilterType === "budget") {
        budget_to = `budget_to=${filterBudgetTo}&`;
      } else if (this.props.FilterType === "plans") {
        budget_to = `planned_sum_to=${filterBudgetTo}&`;
      }
    }

    if (this.props.offerId !== undefined) {
      offerRow = `offer=${this.props.offerId}&`;
    }

    let row = `${buyerRow}${offerRow}${budget_from}${budget_to}`;
    let form_str = row.substring(0, row.length - 1);
    this.props.getFilteredRequest(form_str, this.props.data);
  };

  render() {
    return (
      <StyledRow>
        <Col className="col-12">
          <StyledCard>
            <CardBody
              style={{
                padding: "1.25rem 0",
              }}
            >
              <Row className="justify-content-left">
                <Col sm={"auto"} align="center">
                  <Form className="row gy-2 gx-3 align-items-center">
                    <div className="col-sm-auto">
                      <span>Filter by: </span>
                    </div>
                    <div className="col-sm-auto">
                      <DefaultMultipleSelect
                        options={
                          this.state.mediaBuyers?.length > 0
                            ? this.state.mediaBuyers.map(
                                ({ id, number, checked }) => ({
                                  key: id,
                                  text: number,
                                  checked,
                                })
                              )
                            : []
                        }
                        onChange={this.handleSelectedMediaBuyers}
                        filtered_by="media_buyer"
                        plug="Media buyers: All"
                        search
                        filtered_params={queryString.parse(
                          this.props.history.location.search
                        )}
                      />
                    </div>
                    {this.props.offerId === undefined && (
                      <div className="col-sm-auto">
                        <DefaultMultipleSelect
                          options={
                            this.state.offerTypes?.length > 0
                              ? this.state.offerTypes.map(
                                  ({ id, name, checked }) => ({
                                    key: id,
                                    text: name,
                                    checked,
                                  })
                                )
                              : []
                          }
                          search
                          filtered_by="offer"
                          onChange={this.handleSelectedOffers}
                          plug="Offers: All"
                          filtered_params={queryString.parse(
                            this.props.history.location.search
                          )}
                        />
                      </div>
                    )}
                    <div className="col-sm-auto">
                      <Input
                        type="number"
                        style={{ width: "170px", height: "35px" }}
                        placeholder="Budget from..."
                        value={this.state.filterBudgetFrom || ""}
                        onChange={e =>
                          this.handleChangeBudgetFrom(e.target.value)
                        }
                      />
                    </div>

                    <div className="col-sm-auto">
                      <Input
                        type="number"
                        style={{ width: "170px", height: "35px" }}
                        placeholder="Budget to..."
                        value={this.state.filterBudgetTo || ""}
                        onChange={e =>
                          this.handleChangeBudgetTo(e.target.value)
                        }
                      />
                    </div>
                  </Form>
                </Col>
              </Row>
            </CardBody>
          </StyledCard>
        </Col>
      </StyledRow>
    );
  }
}

const StyledRow = styled.div`
  padding: 0;
  margin: 0;
  z-index: 4;
  position: sticky;
  top: 69px;
`;

const StyledCard = styled(Card)`
  box-shadow: none !important;
  background: #f8f8fb;
  border-radius: 0.1px;
`;

FormToFilter.propTypes = {
  history: PropTypes.any,
  data: PropTypes.object.isRequired,
  getFilteredRequest: PropTypes.func.isRequired,
  dataForAddBudget: PropTypes.any,
  offers: PropTypes.any,
  offerId: PropTypes.node,
  FilterType: PropTypes.string.isRequired,
};

export default FormToFilter;
